import React from 'react';

import Loading from 'core/Loading';
import { useMerchantContext } from 'modules/merchant/MerchantContext';

import InsightRoutes from '../InsightRoutes';
import useInsightV2WoltPlusHidden from '../hooks/useInsightV2WoltPlusHidden';

const FeatureMerchantInsights = () => {
  const { merchant, merchantVenues } = useMerchantContext();
  const { isWoltPlusHidden, isLoading: isLoadingWoltPlusHidden } = useInsightV2WoltPlusHidden(merchant.country);
  if (isLoadingWoltPlusHidden) {
    return <Loading />;
  }
  const activeVenues = merchantVenues?.filter(venue => venue.status === 'VENUE_PUBLISHED');
  return (
    <InsightRoutes
      insightEntity={{
        type: 'merchant',
        id: merchant.itemid.$oid,
        isWoltPlus: !isWoltPlusHidden && merchant.is_part_of_wolt_plus,
        merchant,
        venues: activeVenues,
      }}
    />
  );
};

export default FeatureMerchantInsights;
